import { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMaster } from 'context/MasterContext';
import { useAuth } from 'context/AuthContext';
import MasterEditModal from 'views/MasterManagement/MasterEditModal';

// マスタ編集画面
function MasterManagement() {
  const navigate = useNavigate();

  const master = useMaster();
  const auth = useAuth();

  // マスタ編集モーダルへのパラメタ
  const [editModalParams, setEditModalParams] = useState({});

  // 管理者権限か？
  const [isAdimin] = useState(auth.auth.kbn.some((x) => x === 'admin'));

  // マスタ編集
  const handleOnClickCallModal = (e, tableName) => {
    e.preventDefault();
    setEditModalParams({ tableName: tableName });
  };

  // 工事台帳商品マスタ画面
  const handleOnClickQuoteBase = (e) => {
    e.preventDefault();
    navigate('/admin/ProductsMaster');
  };

  return (
    <>
      <Card className="table-container">
        <Card.Body>
          <Row>
            <Col>
              <div className="bs-callout-info">各種マスタ</div>
            </Col>
          </Row>
          {isAdimin && (
            <Row className="mt-2 ml-1">
              <Col md="2">
                <a href="#" onClick={(e) => handleOnClickCallModal(e, 'M_STAFF')}>
                  ・職員
                </a>
              </Col>
            </Row>
          )}
          {/* <Row className="mt-2 ml-1">
            <Col md="2">
              <a href="#" onClick={(e) => handleOnClickCallModal(e, 'M_LABEL')}>
                ・工事内容タグ
              </a>
            </Col>
          </Row> */}
          <Row className="mt-2 ml-1">
            <Col md="2">
              <a href="#" onClick={(e) => handleOnClickQuoteBase(e)}>
                ・工事台帳商品マスタ
              </a>
            </Col>
            <Col md="2">
              <a href="#" onClick={(e) => handleOnClickCallModal(e, 'M_YEAR_MANAGE_WORK')}>
                ・年間管理作業項目
              </a>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="bs-callout-info">タグ</div>
            </Col>
          </Row>
          <Row className="mt-2 ml-1">
            {master.tagTypes.map((x) => (
              <Col key={x.TAG_TYPE} md="2">
                <a href="#" onClick={(e) => handleOnClickCallModal(e, `M_LABEL_${x.TAG_TYPE}`)}>
                  ・{x.TAG_NAME}
                </a>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>

      {/* マスタ編集モーダル */}
      <MasterEditModal params={editModalParams}></MasterEditModal>
    </>
  );
}

export default MasterManagement;
